import React from 'react'
import './style.css'

const HireCombinationSection = ({ heading, description, combinations, shortHeading }) => {

    return (
        <>
            <div className="hire-combination-section-box-main">
                <div className="container">
                    <div className="row">
                        <div class="col-md-12">
                            <h4 className='low-top-heading text-center'>{shortHeading}</h4>
                            <h2 class="main-heading">{heading}</h2>
                            <p class="description-text text-center">{description}</p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        {combinations?.map((combination, index) => {
                            return <div className="col-xl-6 col-lg-6 col-md-6" key={index}>
                                <div className="hire-combination-card">
                                    <div className="hire-page-combo-icons">
                                        {combination?.icons?.map((icon, index) => {
                                            return <div className="hire-page-combo-icon" key={index}>
                                                <img src={`/images/tech-stack-icons/${icon?.icon}`} alt={icon?.altText} />
                                            </div>
                                        })}
                                    </div>

                                    <div className="hire-page-cmobo-text">
                                        <h2>{combination?.title}</h2>
                                        <p className="common-text">{combination?.description}</p>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default HireCombinationSection